import React from 'react'
import {SmileTwoTone, StarTwoTone, TagsTwoTone} from "@ant-design/icons";
import Text from "antd/es/typography/Text";


const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
}

const iconStyle = {
    marginRight: '8px',
    fontSize: '16px'
}

const countStyle = {
    marginLeft: '8px'
}



const Counts = ({data}) => {
    const {tc, ec, ts} = data
    
    return (
        <React.Fragment>
            <div style={containerStyle}>
                <SmileTwoTone twoToneColor={"#ff5502"} style={iconStyle}/>
                <Text>Toplam Müşteri:</Text>
                <Text strong style={countStyle}>{tc}</Text>
            </div>
            <div style={containerStyle}>
                <StarTwoTone style={iconStyle}/>
                <Text>Kullanıcı Sayısı:</Text>
                <Text strong style={countStyle}>{ec}</Text>
            </div>
            <div style={containerStyle}>
                <TagsTwoTone style={iconStyle}/>
                <Text>Toplam Stok:</Text>
                <Text strong style={countStyle}>{ts}</Text>
            </div>
        </React.Fragment>
    )
}

export default Counts